export default __webpack_public_path__ + "static/media/WindowsTaskScheduler-TriggerDaily02.c24a96e7.png";